import { ProductSearch } from "//orimine.co.jp/cdn/shop/t/9/assets/product-search.js?v=10&v=174879115663272390641791995743";

// 検索とrenderingについて

// URLパラメーターをinputに入れる

$(document).ready(function () {

    const setUpSearchForm = async ()=> {
        // load moreボタンをリッスンする
        const loadMoreButton = document.getElementById('loadMoreButton');
        if (loadMoreButton) {
                loadMoreButton.addEventListener('click', async (e) => {
                e.preventDefault();
                e.target.disabled = true;
                // form属性からformを取得
                const form_id = e.target.getAttribute('data-category-id');
                const form = document.getElementById(`accessory-search-form-${form_id}`);
                await ProductSearch.loadMoreProducts(form).then(() => {
                    e.target.disabled = false;
                });
            });
        }
    }

    const submitSearchForm = async (form) => {
        // ページ読み込み時にURLパラメータをフォームにセット
        const forms = document.getElementsByClassName('accessory-search-form');

        if (forms.length === 0) {
            console.log('フォームが見つかりません');
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        // 2026-07-06 F-14: 風呂敷/手提袋 独立ボタン化で category「風呂敷・手提袋」の
        // form が 2 つ存在する (風呂敷 form / 手提袋 form = tesage_* hidden を持つ方)。
        // URL の tesage_* 有無で「どちらのボタンから来たか」を判別し、submit は 1 form のみ。
        const cameFromTesage = urlParams.has('tesage_oribako_outer_depth');
        let submitted = false;

        // 2026-07-06 UAT 修正 (ふうかさん報告「切替で全件出る」の真因):
        // 旧実装は URL パラメータを「全 form」に書き戻していたため、他カテゴリの
        // 切替ボタン form の Liquid 初期値 (config_gap 等) が前ページの URL 値
        // (空文字含む) で汚染され、切替遷移すると壊れた検索条件で飛んでいた。
        // (例: 手提袋結果 URL の config_gap_inner_*=空 がシート form の -15..0 を破壊)
        // URL 書き戻しは「表示中カテゴリの form (= submit 対象) だけ」に限定し、
        // 切替ボタン form は常に正しい Liquid 初期値を保つ。
        for (let i = 0; i < forms.length; i++) {
            const category_input = forms[i].querySelector('input[name="category"]');
            if (!category_input) continue;
            const category_init_value = category_input.getAttribute('data-init-category');
            const isTesageForm = forms[i].querySelector('input[name="tesage_oribako_outer_depth"]') !== null;
            if (
                category_init_value === urlParams.get('category') &&
                isTesageForm === cameFromTesage &&
                !submitted
            ) {
                submitted = true;
                ProductSearch.setFormFromURLParameters(forms[i]).then(() => {
                    ProductSearch.submitSearchForm(forms[i]);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
            // 非対象 form には何もしない (Liquid 初期値のまま = 汚染防止)
        };
    }

    // ------------------ 画面読み込み時の実行処理 ---------------------

    setUpSearchForm().then(() => {
        submitSearchForm();
    });
});
